<template>
	<section class="mb-8">
		<div class="page-header" style="min-height: 75vh">
			<div
				class="
					oblique
					position-absolute
					top-0
					h-100
					d-md-block d-none
					gradient-custom-10
				"
			>
				<div
					class="
						img-oblique
						position-absolute
						fixed-top
						ms-auto
						h-100
						img-settings
					"
					style="
						margin-left: -4.1rem !important;
						margin-top: 2rem;
						z-index: 0;
						background-size: cover;
						background-position: center center;
						background-image: url('~../../img/BatBall.jpg')
					"
				></div>
			</div>
			<div class="container">
				<div class="row">
					<div
						class="col-lg-6 col-md-7 d-flex justify-content-center flex-column"
					>
						<h2 class="lh-1 ls-tight fw-900 mb-1" style="font-size: 3.75rem">
							six4three
						</h2>
						<h2
							class="lh-1 ls-tight fw-900 text-info mb-4"
							style="font-size: 3.75rem"
						>
							Simplify your league
						</h2>
						<p class="mt-1 pe-lg-5 me-lg-5 lead fw-normal text-muted">
							Manage your league. Set schedules. Add/View/Edit player stats and metrics. Create gameday line-ups. Keep score. Stay up to date with global, league and team feeds. Live stream games for family. The complete league management system.
						</p>
						<div>
							<!-- <router-link type="button" to="SignUp" class="btn btn-outline-info btn-lg mt-4">
								Get Started For Free
							</router-link> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {};
</script>

<style>
.page-header {
	padding: 0;
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	background-size: cover;
	background-position: 50%;
}
.oblique {
	transform: skewX(-10deg);
	overflow: hidden;
	width: 60%;
	right: -10rem;
	border-bottom-left-radius: 0.75rem;
}
.img-oblique {
	transform: skewX(10deg);
}
.img-settings {
	image-rendering: pixelated;
	filter: brightness(110%) contrast(110%) saturate(100%);
}
.fw-900 {
	font-weight: 900;
}
</style>
